import { createFileRoute } from '@tanstack/react-router'
import { BlacklistingRequestHistory } from '@/features/dashboard/blacklisting-request/components/BlacklistingRequestHistory'

export const Route = createFileRoute('/_dashboard/blacklisting-requests/')({
  component: BlacklistingRequestHistoryPage,
})

function BlacklistingRequestHistoryPage() {
  return <BlacklistingRequestHistory />
}
